import { css } from '@emotion/react';
const CSS_VAR_WIDTH = '--local-dynamic-table-width';
export const truncationWidthStyles = css({
  width: `var(${CSS_VAR_WIDTH})`
});
export const fixedSizeTruncateStyles = css({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
export const overflowTruncateStyles = css({
  // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
  '@supports not (overflow-x: clip)': {
    overflow: 'hidden'
  },
  '@supports (overflow-x: clip)': {
    overflowX: 'clip'
  }
});
export const getTruncationStyleVars = ({
  width
}) => typeof width !== 'undefined' ? {
  [CSS_VAR_WIDTH]: `${width}%`
} : undefined;
export const cellStyles = css({
  padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
  border: 'none',
  textAlign: 'left',
  '&:first-of-type': {
    paddingLeft: "var(--ds-space-0, 0px)"
  },
  '&:last-child': {
    paddingRight: "var(--ds-space-0, 0px)"
  }
});